import React from "react";
import { Col, Row, Form, Input, Card } from "antd";
import InputTelefone from "./Input-telefone";

const buildPath = (prefix, field) =>
  Array.isArray(prefix) ? [...prefix, field] : [prefix, field];

const Contato = ({ nome, modoSomenteLeitura, ocultarTitulo = false }) => {
  return (
    <div>
      {/*<div hidden={ocultarTitulo}>
            <h2 className="legend">Contato(s)</h2>
            <div className="linha-legenda"></div>
        </div>*/}
      <Row gutter={[24, 24]}>
        <Col style={{ width: "100%" }}>
          <Card title="Telefone Principal">
            <Col span={12}>
              <Form.Item name={["contato", "telefone1Id"]} hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name={buildPath(nome, "telefone1")}
                label="Telefone"
                rules={[
                  { required: true, message: "Telefone obrigatório" },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();
                
                      const apenasNumeros = value.replace(/\D/g, "");
                
                      if (apenasNumeros.length < 10) {
                        return Promise.reject("Telefone inválido");
                      }
                
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputTelefone
                  className="ant-input"
                  disabled={modoSomenteLeitura}
                />
              </Form.Item>
            </Col>
          </Card>
        </Col>

        <Col style={{ width: "100%" }}>
          <Card title="Telefone Contato">
            <Col span={12}>
              <Form.Item name={["contato", "telefoneContatoId"]} hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name={buildPath(nome, "telefoneContato")}
                label="Telefone"
                normalize={(value) => (value ? value : null)}
                trigger="onBlur"
                getValueFromEvent={(e) => {
                  const value = e?.target?.value;

                  const numeros = value?.replace(/\D/g, "") || "";

                  return numeros.length === 0 ? null : value;
                }}
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve(); // não obrigatório
              
                      const apenasNumeros = value.replace(/\D/g, "");
              
                      if (apenasNumeros.length < 10) {
                        return Promise.reject("Telefone inválido");
                      }
              
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputTelefone
                  className="ant-input"
                  disabled={modoSomenteLeitura}
                />
              </Form.Item>
            </Col>
          </Card>
        </Col>

        {/*<Col span={4}>
            <Form.Item name={[nome, "telefone2"]} label="Whatsapp" rules={[{min:14}]}>
                <InputTelefone className="ant-input" />
            </Form.Item>
        </Col>*/}
        <Col style={{ width: "100%" }}>
          <Card title="E-mail">
            <Col span={12}>
              <Form.Item
                name={buildPath(nome, "email")}
                label="E-Mail"
                rules={[
                  { required: true, message: "O e-mail é obrigatório!" },
                  { type: "email", message: "Digite um e-mail válido!" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Contato;
